<script>
import { defineComponent, onMounted } from 'vue';
import { useRoute } from "vue-router";
//model
import { QueryStringDataBuilder } from "@/core/QueryString/QueryStringDataBuilder";
//service
import BzbsAuth from "@/core/Account/service/BzbsAuth";
//helper
import Utility from "@/helper/Utility";
//feature
import { useModal } from '../feature/ModalFeature';

export default defineComponent({
    setup() {
        const route = useRoute()
        const modal = useModal()

        let queryString = new QueryStringDataBuilder();
        let query = null;

        const auth = async () => {
            query = queryString.setWithQuery(route.query).create();
            console.log(query.accessKey);
            if (!Utility.isEmptyStr(query.accessKey)) {
                const isLoadPayload = await loadPayload(query.accessKey);
                modal.loadingModal.hide();
                if (isLoadPayload) {
                    console.log("isLoadPayload")
                    query.saveCache()
                    window.location.replace('/topup2c2p/home')
                }
            }
        }

        const loadPayload = function (accKey) {
            return new Promise((resolve) => {
                BzbsAuth.apiReadAccessKey(accKey).subscribe({
                    next: (res) => {
                        query = queryString.setWithQuery(res.data, true).create()
                        query.accessKey = accKey
                        resolve(true)
                    },
                    error: (err) => {
                        console.log(err)
                        resolve(false)
                    }
                })
            })
        }

        onMounted(() => {
            auth()
            modal.loadingModal.show();
        })

        return {
        };
    },
});
</script>
<template>
    <div></div>
</template>
<style lang="scss" scoped>
</style>

